import {
  availableFeatureFlags,
  useFeatureFlag,
} from './feature-flags-provider';

export const useCanUseLegalDocuments = () => {
  return useFeatureFlag(availableFeatureFlags.CAN_USE_LEGAL_DOCUMENTS, false);
};
